import React, { useEffect } from 'react'
import './Profile.css'
import user from '../../assets/images/user-avater.png'
import { VariableProfile } from './VariableProfile'
import { editProfile, loadProfileDetails } from '../../store/Actions/ActionProfile'
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../components/general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../components/general/general-component/abstruct-component/useSelectorCustom'
import CheckLazyLoader from '../../components/general/general-component/check-lazy-loader'

function Profile() {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { state, setState, setStateCustom, setLoad } = VariableProfile()
    const { profileDetails, loadingProfileDetails } = useSelectorCustom()
    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(loadProfileDetails(navigate))
    }, [])
    useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            name: profileDetails.name,
            email: profileDetails.email,
        }));
    }, [profileDetails])
    const editProfileInformation = (e) => {
        e.preventDefault()
        dispatch(editProfile(state.name, state.email, state.old_password, state.new_password, state.new_password_confirmation, setLoad))
    }

    return (
        <CheckLazyLoader>
            <main>
                <div className='div_profile margin_main shadow_main' dir={langLocal == "ar" ? "rtl" : "ltr"}  >
                    <div className="profile">
                        <img src={user} />
                        {
                            !loadingProfileDetails ? (
                                <>
                                    <h2 className='head_profile' >{profileDetails.name}</h2>
                                    <span className='span_profile'>{profileDetails.email}</span>
                                    <span className='span_profile'>{profileDetails.role}</span>
                                </>
                            ) : <></>
                        }

                        <div className='editt' disabled >
                            <span>{translate('to_edit_profile')}</span>
                            <i className={langLocal === 'ar' ? 'fa fa-arrow-left' : 'fa fa-arrow-right'} ></i>
                        </div>
                    </div>
                    <div className='div_form_edit' >
                        <h2 className='head_profile' >{translate('edit_profile')}</h2>
                        <div className='form_pop_sign' >
                            <p>{translate('name')}</p>
                            <div className='input_form_pop_sign' >
                                <i className='fa fa-user' ></i>
                                <input defaultValue={state.name} placeholder='Enter Here ...' onChange={(e) => setStateCustom('name', e.target.value)} />
                            </div>
                            <br></br>
                            <p>{translate('email')}</p>
                            <div className='input_form_pop_sign' >
                                <i className='fa fa-envelope' ></i>
                                <input defaultValue={state.email} type='email' placeholder='Enter Here ...' onChange={(e) => setStateCustom('email', e.target.value)} />
                            </div>
                            <br></br>
                            <p>{translate('old_password')}</p>
                            <div className='input_form_pop_sign' >
                                <i className='fa fa-key' ></i>
                                <input type='password' placeholder='Enter Here ...' onChange={(e) => setStateCustom('old_password', e.target.value)} />
                            </div>
                            <br></br>
                            <p>{translate('new_password')}</p>
                            <div className='input_form_pop_sign' >
                                <i className='fa fa-key' ></i>
                                <input type='password' placeholder='Enter Here ...' onChange={(e) => setStateCustom('new_password', e.target.value)} />
                            </div>
                            <br></br>
                            <p>{translate('new_password_confirmation')}</p>
                            <div className='input_form_pop_sign' >
                                <i className='fa fa-key' ></i>
                                <input type='password' placeholder='Enter Here ...' onChange={(e) => setStateCustom('new_password_confirmation', e.target.value)} />
                            </div>
                            <br></br>
                            <button onClick={editProfileInformation} >
                                {
                                    state.Load ? "Loading ..." : `${translate('edit')}`
                                }
                            </button>
                        </div>
                    </div>
                </div>
                <br></br>
            </main>
        </CheckLazyLoader>
    )
}

export default Profile